// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._19pk1epz{margin-top:var(--ds-space-1000,5pc)}\n._1wybckbl{font-size:3pc}\n._4t3i8vuz{height:56px}\n._k48pmoej{font-weight:var(--ds-font-weight-bold,700)}\n._otyr1epz{margin-bottom:var(--ds-space-1000,5pc)}\n._vwz48vuz{line-height:56px}", ""]);
// Exports
module.exports = exports;
